export default [
  {
    name: 'Informes',
    icon: 'mdi-finance',
    path: '/admin/reports/',
    component: () => import(/* webpackChunkName: "admin-reports" */ './views/ReportListPage.vue'),
    meta: {
      admin: true,
      adminToolbar: false,
      adminDrawer: true,
      tooltip: null,
      allowedRoles: ['superadmin', 'admin'],
    },
  },
];
